import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import '../custom-build/steps.scss';

import buttonarrow from '../../assets/images/button-arrow.svg';
import person from '../../assets/images/person.svg';
import artworkproofingimg from '../../assets/images/artwork-proofing.svg';

class ArtworkProofingView extends Component {
    render() {
        return (
          <div className="home-content steps-content">
              <div className="homeleftcontent steps-left">
                <Fade right>
                    <h4>Phone calls and emails are a thing of the past. CustomBuilt allows your customers to review and approve artwork digitally in just a few clicks.</h4>
                </Fade>
                <Fade right><p className="steps-text">Create multiple versions of proof templates for you customer to review and approve from.</p></Fade>
                    <Fade right>
                        <div className="button-section">
                            <Link to="/orderentry" className="theme-btn backarrow-btn"><img alt="" src={buttonarrow} /></Link>
                            <Link to="/Production" className="theme-btn">Production <img alt="" src={buttonarrow} /></Link>
                        </div>  
                </Fade>
                <div className="bottom-person">
                    <Fade right>
                        <img alt="Customer Portal" src={person} />
                        <div className="person-right">
                            <h3>Approve or reject artwork</h3>
                            <small>Customer Portal</small>
                        </div>
                    </Fade>
                </div>
              </div>
              <div className="homerightcontent align-items-center">
                  <Fade right>
                      <img alt="Custom Built" className="w-100 artworkproofing-img" src={artworkproofingimg} />
                  </Fade>
              </div>
          </div>
        )
    }
}

export default ArtworkProofingView
